import styled from 'styled-components';

import { ContentColor, contentColorMap } from '../../../contentColor';
import { FontWeight, fontWeightMap } from '../../../fontWeight';
import commonParagraphStyles from '../common/styles';

interface P3Props {
	contentColor?: ContentColor;
	fontWeight?: FontWeight;
	textShadow?: boolean;
}

const P3 = styled.p.withConfig({
	shouldForwardProp: (prop) => prop !== 'contentColor' && prop !== 'fontWeight' && prop !== 'textShadow',
})<P3Props>`
	${commonParagraphStyles};
	text-shadow: ${({ textShadow }) => (textShadow ? '0 0 5px rgba(255, 255, 255, 0.5)' : 'none')};
	font-weight: ${({ fontWeight }) => (fontWeight ? fontWeightMap[fontWeight] : 400)};
	color: ${({ theme, contentColor }) => (contentColor ? contentColorMap[contentColor](theme) : theme.colors.dark)};
	font-size: 1rem;
	line-height: 171%;
	margin: 0;
	font-style: normal;
`;

export default P3;
